var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31547 0.0602099C8.21788 0.0213603 8.11143 0 7.99999 0C7.87967 0 7.76518 0.0248975 7.66136 0.0698212C7.57981 0.105039 7.50263 0.15358 7.43314 0.215444C7.41924 0.227806 7.40574 0.240616 7.39268 0.253851L3.42611 4.22041C3.09285 4.55368 3.09285 5.09401 3.42611 5.42728C3.75938 5.76055 4.29972 5.76055 4.63298 5.42728L7.1466 2.91366V10.3818C7.1466 10.8532 7.52868 11.2352 7.99999 11.2352C8.4713 11.2352 8.85337 10.8532 8.85337 10.3818V2.91361L11.367 5.42728C11.7003 5.76055 12.2406 5.76055 12.5739 5.42728C12.9072 5.09401 12.9072 4.55368 12.5739 4.22041L8.60345 0.249951C8.5186 0.165101 8.42033 0.101854 8.31547 0.0602099Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.853385 9.52846C1.3247 9.52846 1.70677 9.91053 1.70677 10.3818V13.558C1.70677 13.753 1.78423 13.94 1.92212 14.0779C2.06 14.2158 2.24701 14.2932 2.44201 14.2932H13.558C13.753 14.2932 13.94 14.2158 14.0779 14.0779C14.2158 13.94 14.2932 13.753 14.2932 13.558V10.3818C14.2932 9.91053 14.6753 9.52846 15.1466 9.52846C15.6179 9.52846 16 9.91053 16 10.3818V13.558C16 14.2057 15.7427 14.8268 15.2848 15.2848C14.8268 15.7427 14.2057 16 13.558 16H2.44201C1.79435 16 1.17321 15.7427 0.715247 15.2848C0.257282 14.8268 0 14.2057 0 13.558V10.3818C0 9.91053 0.382074 9.52846 0.853385 9.52846Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.e75c3a07.svg";
export { ForwardRef as ReactComponent };